import { render } from "./Likelihood_Impact.vue?vue&type=template&id=f36e63d8&scoped=true"
import script from "./Likelihood_Impact.vue?vue&type=script&lang=js"
export * from "./Likelihood_Impact.vue?vue&type=script&lang=js"

import "./Likelihood_Impact.vue?vue&type=style&index=0&id=f36e63d8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f36e63d8"

export default script